export default __webpack_public_path__ + "static/media/cost-control.72538d16.svg";